// @material-ui/icons
import PeopleIcon from '@material-ui/icons/People'
import KingBedIcon from '@material-ui/icons/KingBed'

import DirectionsRunIcon from '@material-ui/icons/DirectionsRun'
import AdminTenantsTab from '../components/tenant/admin/tab/TenatsTab'
import AdminDeparturesTab from '../components/tenant/admin/tab/AdminDeparturesTab'
import AdminClaimsTab from '../components/tenant/admin/tab/AdminClaimsTab'
import AdminSubtenantsTab from '../components/tenant/admin/tab/SubtenatsTab'
import AssignmentIcon from '@material-ui/icons/Assignment'
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd'
import AdminParcelTab from '../components/parcel/ParcelTab'
import AllInboxIcon from '@material-ui/icons/AllInbox'
import CurrentHSV from '../components/engagement/CurrentHSV'

export let adminRoutes = [
  {
    path: '/dashboard/admin/tenants',
    name: 'Bewohner',
    icon: PeopleIcon,
    component: AdminTenantsTab,
  },
  {
    path: '/dashboard/admin/departures',
    name: 'Auszüge',
    icon: DirectionsRunIcon,
    component: AdminDeparturesTab,
  },
  {
    path: '/dashboard/admin/claims',
    name: 'Verlängerungsanträge',
    icon: AssignmentIcon,
    component: AdminClaimsTab,
  },
  {
    path: '/dashboard/admin/subtenants',
    name: 'Untermiete',
    icon: KingBedIcon,
    component: AdminSubtenantsTab,
  },
  {
    path: '/dashboard/admin/departments/current',
    name: 'HSV',
    icon: AssignmentIndIcon,
    component: CurrentHSV,
  },
  {
    path: '/dashboard/admin/pakete',
    name: 'Pakete',
    icon: AllInboxIcon,
    component: AdminParcelTab,
  },
]
